export default __webpack_public_path__ + "static/logo-district-92c00db35fdc6e1a9879ef1b83cefdda.png";